import { render, staticRenderFns } from "./otherUserData.vue?vue&type=template&id=10530139&scoped=true&"
import script from "./otherUserData.vue?vue&type=script&lang=js&"
export * from "./otherUserData.vue?vue&type=script&lang=js&"
import style0 from "./otherUserData.vue?vue&type=style&index=0&id=10530139&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10530139",
  null
  
)

export default component.exports